import React from 'react'
import PropTypes from 'prop-types'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import { ROLE_CUSTOMER_SERVICE_TEAM_LEAD, ROLE_EMPLOYEE } from '../../../security/state/auth/const'
import TreatmentPlanFileUploadContainer from '../scan-file-upload/TreatmentPlanFileUploadContainer'
import TreatmentPlanExternalFileUploadContainer from '../scan-file-upload/TreatmentPlanExternalFileUploadContainer'
import ProductionFileUploadContainer from '../scan-file-upload/ProductionFileUploadContainer'
import ScanFileUploadContainer from '../scan-file-upload/ScanFileUploadContainer'
import OtherFileUploadContainer from '../scan-file-upload/OtherFileUploadContainer'
import ImplantScanFileUploadContainer from '../scan-file-upload/ImplantScanFileUploadContainer'
import XRayFileUploadContainer from '../scan-file-upload/XRayFileUploadContainer'
import { TAB_FILES } from '../../state/detail/const'
import ConformityWidgetContainer from '../task-widget/ConformityWidgetContainer'
import CbctFileUploadContainer from '../cbct-file-upload/CbctFileUploadContainer'
import CustomsInvoiceListWidgetContainer from '../../../sales-order/component/task-widget/CustomsInvoiceListWidgetContainer'


const TabFiles = (props) => {
    const { tab, customer } = props
    if (tab !== TAB_FILES) {
        return null
    }
    return (

        <React.Fragment>

            <ScanFileUploadContainer
                customer={customer}
                readOnly={false}
            />

            <Authorization requiredRole={ROLE_CUSTOMER_SERVICE_TEAM_LEAD}>
                <OtherFileUploadContainer customer={customer} readOnly={false}/>
            </Authorization>

            <XRayFileUploadContainer
                customer={customer}
                readOnly={false}
            />

            <ImplantScanFileUploadContainer
                customer={customer}
                readOnly={false}
            />

            <CbctFileUploadContainer customer={customer}/>

            <Authorization requiredRole={ROLE_EMPLOYEE}>
                <TreatmentPlanFileUploadContainer customer={customer}/>
                <TreatmentPlanExternalFileUploadContainer customer={customer}/>
                <ProductionFileUploadContainer customer={customer}/>
            </Authorization>

            <ConformityWidgetContainer customer={customer} readOnly={false} />

            <CustomsInvoiceListWidgetContainer customer={customer} readOnly={true}/>

        </React.Fragment>

    )
}

TabFiles.propTypes = {
    tab: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
}

export default TabFiles



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TabFiles.js